import FormAddNewBankAccount from 'components/FormEditReceiver/components/FormAddNewBankAccount';
import FormAddNewEwalletAccount from 'components/FormEditReceiver/components/FormAddNewEwalletAccount';
import {
  METHOD_BANK,
  METHOD_EWALLET,
  RESET_EDIT_RECEIVER_INFORMATION_STORE,
} from 'constants';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import useForm from 'hooks/form/useForm';
import useDeliveryMethods from 'hooks/useDeliveryMethods';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import useUpdateReceiverStore from '../hooks/useUpdateReceiverStore';

const initialFormField = RESET_EDIT_RECEIVER_INFORMATION_STORE.accountDetails;
const initialFormBank =
  RESET_EDIT_RECEIVER_INFORMATION_STORE.accountDetails.bank;
const initialFormEwallet =
  RESET_EDIT_RECEIVER_INFORMATION_STORE.accountDetails.ewallet;

const withUpdateReceiverAccountDetailsInitial = (Component) => {
  const UpdateReceiverAccountDetailsInitialComponent = (props) => {
    const { countryConfig } = props || {};

    const {
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    } = useForm(initialFormField);

    const {
      information: bankInformation,
      setInformation: setBankInformation,
      validation: bankValidation,
      setValidation: setBankValidation,
    } = useForm(initialFormBank);

    const {
      information: ewalletInformation,
      setInformation: setEwalletInformation,
      validation: ewalletValidation,
      setValidation: setEwalletValidation,
    } = useForm(initialFormEwallet);

    const [isOpenFormAddNewBank, setOpenFormAddNewBank] = useState(false);
    const [isOpenFormAddNewEwallet, setOpenFormAddNewEwallet] = useState(false);
    const [isBanksChecked, setBanksChecked] = useState(true);

    const {
      currentReceiver,
      editReceiverInformation,
      setAddReceiverAccountDetails,
    } = useFormAddReceiverStore();
    const { accountDetails } = editReceiverInformation || {};

    const { isAccountDetailsInformationChanged } = useUpdateReceiverStore();

    const deliveryMethods = useDeliveryMethods(
      countryConfig ? countryConfig?.countryCode : null,
    );

    useEffect(() => {
      if (isEmpty(currentReceiver)) return;
      if (isAccountDetailsInformationChanged) return;

      console.log(
        `⭐ withUpdateReceiverAccountDetailsInitial 👉 useEffect ➡️ 1 ➡️ newInformation ↩`,
        currentReceiver,
      );
      setInformation(currentReceiver);

      setValidation(null);
    }, [currentReceiver, isAccountDetailsInformationChanged]);

    useEffect(() => {
      if (
        deliveryMethods?.includes(METHOD_BANK) &&
        deliveryMethods?.includes(METHOD_EWALLET)
      ) {
        return;
      }

      if (deliveryMethods?.includes(METHOD_BANK)) {
        return;
      }

      if (deliveryMethods?.includes(METHOD_EWALLET)) {
        setBanksChecked(false);
      }
    }, [deliveryMethods]);

    useEffect(() => {
      if (isEmpty(accountDetails)) return;
      if (!isAccountDetailsInformationChanged) return;

      const informationStore = accountDetails;

      console.log(
        `⭐ withUpdateReceiverAccountDetailsInitial 👉 useEffect ➡️ 2 ➡️ newInformation ↩`,
        informationStore,
      );
      setInformation(informationStore);
    }, [accountDetails, setInformation, isAccountDetailsInformationChanged]);

    const handleOnToggleFormAddNewBank = (informationLatest = null) => {
      setBankInformation(initialFormBank);

      setOpenFormAddNewBank(!isOpenFormAddNewBank);

      setValidation(null);

      if (!isEmpty(informationLatest)) {
        setAddReceiverAccountDetails(informationLatest);
      }
    };
    const renderFormAddNewBank = () => {
      if (!isOpenFormAddNewBank) return null;
      return (
        <FormAddNewBankAccount
          isOpen={isOpenFormAddNewBank}
          countryConfig={countryConfig}
          currentReceiver={currentReceiver}
          information={information}
          setInformation={setInformation}
          bankInformation={bankInformation}
          setBankInformation={setBankInformation}
          bankValidation={bankValidation}
          setBankValidation={setBankValidation}
          onClose={handleOnToggleFormAddNewBank}
        />
      );
    };

    const handleOnToggleFormAddNewEwallet = (informationLatest = null) => {
      setEwalletInformation(initialFormEwallet);

      setOpenFormAddNewEwallet(!isOpenFormAddNewEwallet);

      setValidation(null);

      if (!isEmpty(informationLatest)) {
        setAddReceiverAccountDetails(informationLatest);
      }
    };
    const renderFormAddNewEwallet = () => {
      if (!isOpenFormAddNewEwallet) return null;
      return (
        <FormAddNewEwalletAccount
          isOpen={isOpenFormAddNewEwallet}
          countryConfig={countryConfig}
          information={information}
          setInformation={setInformation}
          ewalletInformation={ewalletInformation}
          setEwalletInformation={setEwalletInformation}
          ewalletValidation={ewalletValidation}
          setEwalletValidation={setEwalletValidation}
          onClose={handleOnToggleFormAddNewEwallet}
        />
      );
    };

    const newProps = {
      ...props,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
      bankInformation,
      setBankInformation,
      bankValidation,
      setBankValidation,
      ewalletInformation,
      setEwalletInformation,
      ewalletValidation,
      setEwalletValidation,
      isBanksChecked,
      setBanksChecked,
      handleOnToggleFormAddNewBank,
      handleOnToggleFormAddNewEwallet,
      deliveryMethods,
    };
    return (
      <>
        {renderFormAddNewBank()}
        {renderFormAddNewEwallet()}
        <Component {...newProps} />
      </>
    );
  };
  return UpdateReceiverAccountDetailsInitialComponent;
};

export default withUpdateReceiverAccountDetailsInitial;
